import TemplateView from '../../../../../TemplateView'
import InputField from '../../../../../components/InputField'
import messageResource from '../../../../../messageResource'
import _ from 'underscore'

export default class AdditionalInvoiceDetails extends TemplateView {

    constructor({
        vatNumberChangeCallback = () => {},
        poNumberChangeCallback = () => {},
    }) {
        super()

        this.callbacks = {
            vatNumberChangeCallback,
            poNumberChangeCallback
        }

        this.state = {
            vatNumber: '',
            poNumber: '',
        }

        this.onStatePropertyChanged('vatNumber', (vatNumber) => {
            this.vat.setState({
                value: vatNumber
            })
        })

        this.onStatePropertyChanged('poNumber', (poNumber) => {
            this.po.setState({
                value: poNumber
            })
        })
    }

    templateHtml() {
        return '<div class="additionalInvoice">' +
               '    <div class="title"><%=title%></div>' +
               '    <div class="inputsContainer"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'licenses.purchase.purchase_step.additional_invoice_detail',
        }
    }

    afterRender() {
        this.vat = new InputField({
            additionalClass: 'vat',
            maxLength: 60,
            placeholder: messageResource.getMessage('licenses.purchase.purchase_step.additional_invoice.placeholder.vat'),
            onChange: (vatNumber) => {
                this.callbacks.vatNumberChangeCallback(vatNumber)
            },
        }).init(this.find('.inputsContainer'))

        this.po = new InputField({
            additionalClass: 'po',
            maxLength: 60,
            placeholder: messageResource.getMessage('licenses.purchase.purchase_step.additional_invoice.placeholder.po'),
            onChange: (poNumber) => this.callbacks.poNumberChangeCallback(poNumber),
        }).init(this.find('.inputsContainer'))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/paymentStep/AdditionalInvoiceDetails.js